/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { WorkProgressDto } from './WorkProgressDto';
import {
    instanceOfWorkProgressDto,
    WorkProgressDtoFromJSON,
    WorkProgressDtoFromJSONTyped,
    WorkProgressDtoToJSON,
} from './WorkProgressDto';

/**
 * @type JobOccurrenceDtoWorkProgressSummary
 * 
 * @export
 */
export type JobOccurrenceDtoWorkProgressSummary = WorkProgressDto;


export function JobOccurrenceDtoWorkProgressSummaryFromJSON(json: any): JobOccurrenceDtoWorkProgressSummary {
    return JobOccurrenceDtoWorkProgressSummaryFromJSONTyped(json, false);
}

export function JobOccurrenceDtoWorkProgressSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobOccurrenceDtoWorkProgressSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...WorkProgressDtoFromJSONTyped(json, true) };
    return  WorkProgressDtoFromJSONTyped(json, true);
}

export function JobOccurrenceDtoWorkProgressSummaryToJSON(value?: JobOccurrenceDtoWorkProgressSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfWorkProgressDto(value)) {
        return WorkProgressDtoToJSON(value as WorkProgressDto);
    }

    return {};
}

/**
 * Check if a given object implements the JobOccurrenceDtoWorkProgressSummary interface.
 */
export function instanceOfJobOccurrenceDtoWorkProgressSummary(value: any): value is JobOccurrenceDtoWorkProgressSummary {
    if (instanceOfWorkProgressDto(value)) return true;
    return false;
}

